module.exports = __webpack_public_path__ + "img/8.d52e1403.jpg";